import { render, staticRenderFns } from "./AlvaroValidateHeader.vue?vue&type=template&id=10863e87"
var script = {}
import style0 from "./AlvaroValidateHeader.vue?vue&type=style&index=0&id=10863e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports